import { render, staticRenderFns } from "./SWSHeader.vue?vue&type=template&id=43eef0b5&scoped=true&"
import script from "./SWSHeader.vue?vue&type=script&lang=js&"
export * from "./SWSHeader.vue?vue&type=script&lang=js&"
import style0 from "./SWSHeader.vue?vue&type=style&index=0&id=43eef0b5&scoped=true&lang=css&"
import style1 from "./SWSHeader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43eef0b5",
  null
  
)

export default component.exports